import { BaseModel } from "./BaseModel";

export class Category extends BaseModel {
  schema = "/category";
  constructor(params) {
    return super(params, "/category");
  }
}
